import React, { useState, useEffect } from 'react'
import api from '../components/api'
import axios from 'axios'


const Modal = (props) => {

    
    var hospClima_id = props.hospClima_id
    
    var adesao_institucional_id = props.adesao_institucional_id



    var [tipoInventario, setTipoInventario] = useState('')
    var [nomeArquivo, setNomeArquivo] = useState('')
    var [statusProcessamentoArquivo, setStatusProcessamentoArquivo] = useState('')
    var [ano, setAno] = useState()

    //console.log(props)


    async function carrega() {

        await api.get(`desafioClimaPlanilhaInfo/${hospClima_id}`).then((result) => {

            //console.log(result.data, 'aaa')

            var data = result.data[0]

            if (data) {


                var statusProcessamentoArquivoTemp = data.statusProcessamentoArquivo

                switch (statusProcessamentoArquivoTemp) {

                    case 'P':
                        var statusProcessamentoArquivoTemp_descri = 'Pendente'
                        break

                    case 'V':
                        var statusProcessamentoArquivoTemp_descri = 'Validado'
                        break

                }


                setTipoInventario(data.tipoInventario)
                setNomeArquivo(data.nomeArquivo)
                setStatusProcessamentoArquivo(statusProcessamentoArquivoTemp_descri)
                setAno(data.ano)


            }

        }).catch((err) => {

            console.log(err.response)

        })

    }


    function processaPlanilhaGHG() {


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma processar a planilha?',
		    buttons: {
		        Sim: function () {

                    //console.log(dataPost)

                    var headers = {

                        'Content-type': 'application/json',
                        'x-access-token': '!nf0$@ud#2'

                    }

                    var dataPost = {

                        "proc_id": null,
                        "adesao_institucional_id": adesao_institucional_id,
                        "ano": ano,
                        "nomeArquivo": nomeArquivo


                    }

                    console.log(dataPost)
                    //return false

                    
                    axios.post(`https://api3.hospitaissaudaveis.org/verifica`, dataPost, {headers: headers}).then((result) => {

                        console.log(result.data)

                        if (result.data[0].status == 'ok') {

                            window.toastr.success('Arquivo encaminhado para processamento!')
                            return false

                        } else {

                            window.toastr.error('Ocorreu um problema, por favor contacte o administrador do sistema')
                            return false

                        }

                    }).catch((err) => {

                        console.log(err.response)

                    })
                    
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });


    }

    function downloadPlanilhaGHG() {


        if (nomeArquivo) {


            window.location.href = `https://cdn.hospitaissaudaveis.org/uploads/desafioClima/${nomeArquivo}`


        }



    }


    useEffect(() => {


        carrega()
        console.log(adesao_institucional_id)


    }, [hospClima_id])


    return (

        <div>


                <div className="modal fade" id="modalProcessaPlanilhaClima" tabindex="-1" role="dialog">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h1 className="modal-title">Planilha GHG</h1>
                            </div>
                            <div class="modal-body">
                                    
                                    <div class="panel-body">


                                        <div class="col-md-9">
                                            <div class="form-group">
                                                <label>Tipo de inventário</label>
                                                <select className="form-control" value={tipoInventario} onChange={event => setTipoInventario(event.target.value)}>
                                                    <option value="">[Selecione]</option>
                                                    <option value="B">Conteúdo Básico</option>
                                                    <option value="A">Conteúdo Avançado</option>
                                                </select>
                                                                
                                            </div>
                                        </div>

                                        <div className="col-md-3">
                                            <div class="form-group" >
                                                <label className="control-label">Ano:</label>
                                                <input type="text" className="form-control" value={ano} disabled />
                                                    

                                            </div>
                                        </div>

                                        <div className="col-md-12">
                                            <div class="form-group" >
                                                <label className="control-label">Arquivo:</label>
                                                <input type="text" className="form-control" value={nomeArquivo} disabled />
                                                    

                                            </div>
                                        </div>

                                        <div className="col-md-12">
                                            <div class="form-group" >
                                                <label className="control-label">Status:</label>
                                                <input type="text" className="form-control" id="statusPlanilha" value={statusProcessamentoArquivo} disabled />
                                                    

                                            </div>
                                        </div>
                                        


                                    </div>


                            </div>
                            <div className="modal-footer">

                                <button type="button" className="btn btn-success" onClick={() => downloadPlanilhaGHG()} style={{ display: nomeArquivo ? 'table-row' : 'none'}}>Download planilha</button>
                                <button type="button" className="btn btn-info" onClick={() => processaPlanilhaGHG()} style={{ display: nomeArquivo ? 'table-row' : 'none'}}>Processar planilha</button>
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>
                                
                            </div>
                        </div>
                    </div>
                </div>

        </div>


    )



}


    

export default Modal